import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";
import AgentProfile from "./AgentProfile";
import ProcessAndCoachable from "./ProcessAndCoachable";
import AgentRecom from "./AgentRecom";
import InfoIcon from "@mui/icons-material/Info";

const AgentAnalysis = ({ agentAnalytics, overview }) => {
  return (
    <>
      <Box>
        <Typography
          variant="h5"
          component="h1"
          fontWeight="bold"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          Agent Analysis
          <Tooltip
            title="Give the agent's performance metrics, this is majorly from the client's side."
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InfoIcon
              sx={{
                fontSize: 18,
                color: "grey",
              }}
            />
          </Tooltip>
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Detailed performance analysis of agent communication, process
          adherence, and coaching opportunities.
        </Typography>
      </Box>
      <Box>
        <AgentProfile agentAnalytics={agentAnalytics} overview={overview} />
        <ProcessAndCoachable agentAnalytics={agentAnalytics} />
        {/* <AgentRecom agentAnalytics={agentAnalytics} /> */}
      </Box>
    </>
  );
};

export default AgentAnalysis;
